module.exports = __webpack_public_path__ + "static/media/Delete.394085e5.svg";